export default __webpack_public_path__ + "media/images/profil-6aca61d98bca46d82e74129a3785f8d9.png";